@for (option of visibleOptions; track trackOption(index, option); let index = $index) {
  <div
    (click)="pick(index)"
    [ngClass]="{ picked: option.picked }"
    [zalamoTooltip]="option.description | langPicker | async"
    class="option"
    >
    @if (iconMode) {
      <div class="icon">
        @if (option.icon) {
          <img
            [src]="option.icon | publicImageUrl: 400:400:'zalamo' | async"
            />
        }
        @if (!option.icon) {
          <div></div>
        }
      </div>
    }
    <span>
      {{ option.label | langPicker | async }}
    </span>
  </div>
}
